import type { ConfigType } from '@plone/registry';
import EventView from '../components/Views/EventView';
import NewsItemView from '../components/Views/NewsItemView';
// import EventView from '@plone/volto/components/theme/View/EventView';

export default function install(config: ConfigType) {
  config.views = {
    ...config.views,
    contentTypesViews: {
      ...config.views.contentTypesViews,
      // Event: EventView,
      // 'News Item': NewsItemView,
    },
  };

  // delete the default views for Event and News Item
  delete config.views.contentTypesViews.Event;
  delete config.views.contentTypesViews['News Item'];

  return config;
}
